// extracted by mini-css-extract-plugin
export default {"dlIntegerFormatter":"src-js-common-components-formatters-IntegerFormatter---dlIntegerFormatter---aAIzz"};